import React, { useState } from "react";
import { Box } from "@mui/material";
import { useAtomValue } from "jotai";
import { isAuthenticatedAtom, userAccountAtom } from "@store/HostAtoms";
import { useAuthInitializer } from "@hooks/useAuthInitializer";
import AppHeader from "@components/AppHeader";
import Footer from "@components/Footer";
import styles from "@style/AuthProvider.module.css";
//import { useSecurityGroup } from "@hooks/useSecurityGroup";

const AuthProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  useAuthInitializer();
  //useSecurityGroup();
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const account = useAtomValue(userAccountAtom);

  const [, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);

  return (
    <Box className={styles.main_container}>
      <AppHeader
        name={account?.name || ""}
        isAuthenticated={isAuthenticated}
        onMenuClick={handleClick}
      />
      {isAuthenticated && <Box className={styles.remote_container}>{children}</Box>}
      <Footer />
    </Box>
  );
};

export default AuthProvider;
